import React from 'react';
import styled from 'styled-components/macro';
import { Multiselect as WidgetMultiselect } from 'react-widgets/cjs';

const Multiselect = styled(WidgetMultiselect)(({
  $bgColor,
  $color
}: {
  $bgColor?: string,
  $color?: string
}) => `
  ${$bgColor ? `
  & .rw-multiselect-tag {
    background: ${$bgColor};
  }
  `: ''}

  ${$color ? `
  & .rw-multiselect-tag,
  & button svg {
    color: ${$color};
  }
  `: ''}
`);

export default <T extends { [k: string]: any }>({
  dataKey,
  textField,
  value,
  data,
  bgColor,
  color,
  readonly = false,
  onChange
}: {
  dataKey: keyof T,
  textField: keyof T,
  value?: T[],
  data: T[],
  bgColor?: string,
  color?: string,
  readonly?: boolean,
  onChange?: (v: T[]) => void
}) => {
  return (
    <Multiselect
      dataKey={dataKey as string}
      textField={textField as string}
      value={value}
      data={data}
      $bgColor={bgColor}
      $color={color}
      onChange={v => onChange && onChange(v as T[])}
      readOnly={readonly}
    />
  );
}